export * from 'server/models/PostalAddress';


// WEBPACK FOOTER //
// ./data/models/PostalAddress.ts